/**
 * 租户间稿库左侧
 * 2019-05-17
 * zhang.yingyu
 */
"use strict";
angular.module('tenantManuscriptLeftModule', []).
directive("tenantManuscriptLeft", ["$state", "$timeout", "resourceCenterService", "$stateParams", function($state, $timeout, resourceCenterService, $stateParams) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            selectedParent: '='
        },
        templateUrl: './resourceCenter/tenantManuscript/left/left_tpl.html',
        link: function($scope, $elem, $attrs) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    id: $stateParams.id,
                    selectedTenant: '',
                };
            }

            function initData() {
                $scope.firstNav = $scope.selectedParent.value;
                if ($scope.status.id) {
                    $scope.status.selectedTenant = $scope.firstNav.filter((item) => {
                        return item.TENANTID == $scope.status.id;
                    })[0];
                    autoSkip($scope.selectedParent.routerPart, $scope.status.selectedTenant.TENANTID);
                } else {
                    $scope.status.selectedTenant = $scope.firstNav[0];
                    autoSkip($scope.selectedParent.routerPart, $scope.status.selectedTenant.TENANTID);
                }
            }

            /**
             * [autoSkip 自动跳转路由]
             * @param  {[type]} router   [description]
             * @param  {[type]} tenantid [description]
             * @return {[type]}          [description]
             */
            function autoSkip(router, tenantid) {
                if (router == "tenantManuscriptResource.post") {
                    $state.go("front.resourcectrl.tenantmanuscript.post", { id: tenantid }, { reload: "front.resourcectrl.tenantmanuscript.post" });
                } else if (router == "tenantManuscriptResource.receive") {
                    $state.go("front.resourcectrl.tenantmanuscript.receive", { id: tenantid }, { reload: "front.resourcectrl.tenantmanuscript.receive" });
                }
            }

            /**
             * [setSelected 选中合作租户]
             * @param {[type]} item [description]
             */
            $scope.setSelected = function(item) {
                $scope.status.selectedTenant = item;
                autoSkip($scope.selectedParent.routerPart, $scope.status.selectedTenant.TENANTID);
            };

            $scope.$watch('selectedParent', function(newV, oldv) {
                if (newV != oldv && newV.value.length > 0) {
                    $scope.firstNav = $scope.selectedParent.value;
                    if ($stateParams.id) {
                        $scope.status.id = $stateParams.id;
                        $scope.status.selectedTenant = $scope.firstNav.filter((item) => {
                            return item.TENANTID == $scope.status.id;
                        })[0];
                        autoSkip($scope.selectedParent.routerPart, $scope.status.selectedTenant.TENANTID);
                    }
                }
            });
        }
    };
}]);